import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=99b9b0be&scoped=true&"
var script = {}
import style0 from "./Error404.vue?vue&type=style&index=0&id=99b9b0be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b9b0be",
  null
  
)

export default component.exports